import React, { memo } from 'react'
import { Button } from 'transfix-ui/components/Button'
import { Card } from 'transfix-ui/components/Card'
import { InlineEditContainer } from 'transfix-ui/components/InlineEditContainer'
import { Equipment } from 'apps/fleet-planner/components/form-components/Equipment'
import { EquipmentDetails } from 'apps/fleet-planner/components/load-details/Details'
import { LockedTooltip } from 'apps/fleet-planner/components/load-details/LockedTooltip'
import { EQUIPMENT_TYPE } from 'apps/fleet-planner/constants/loads'
import { ILoadEquipment, ITemperatureSetting } from 'apps/fleet-planner/types/loads'
import { LOAD_FIELDS } from 'apps/fleet-planner/utils/permissions'

interface IEquipmentInlineEditProps {
  trailerType?: EQUIPMENT_TYPE
  trailerLength?: string
  temperatureSetting?: ITemperatureSetting
  currentEditField?: string
  onEditModeRequested: (name?: string) => void
  onChange: (change: Partial<ILoadEquipment>) => void
  onSave: () => void
  onCancel: () => void
  isLocked?: boolean
  securingOptions?: string
  isLoading?: boolean
}

export const EquipmentInlineEdit = memo<IEquipmentInlineEditProps>(
  ({
    currentEditField,
    isLoading,
    isLocked,
    onCancel,
    onChange,
    onEditModeRequested,
    onSave,
    securingOptions,
    temperatureSetting,
    trailerLength,
    trailerType,
  }) => {
    const NAME = LOAD_FIELDS.equipment
    const isEditMode = currentEditField === NAME

    return (
      <InlineEditContainer
        isLoading={isLoading}
        isLocked={isLocked}
        lockedIcon={<LockedTooltip className='locked-icon' />}
        dataTest='load-details-equipment-section'
        name={NAME}
        editModeEnabled={isEditMode}
        onEditModeRequested={onEditModeRequested}
        resetOnClickOutside={false}
        editMode={
          <Card className='pa4'>
            <Equipment
              trailerType={trailerType}
              trailerLength={trailerLength}
              temperatureSetting={temperatureSetting}
              onChange={onChange}
            />
            <div className='tr'>
              <div className='mt4'>
                <Button
                  color='tertiary'
                  size='large'
                  data-test='equipment-cancel-button'
                  onClick={onCancel}>
                  Cancel
                </Button>
                <Button
                  color='primary'
                  size='large'
                  data-test='equipment-save-button'
                  onClick={onSave}>
                  Save
                </Button>
              </div>
            </div>
          </Card>
        }>
        <EquipmentDetails
          securingOptions={securingOptions}
          trailerType={trailerType}
          trailerLength={trailerLength}
          temperatureSetting={temperatureSetting}
        />
      </InlineEditContainer>
    )
  }
)
